export * from './TextGallery';

import { TextGallery } from './TextGallery';

export default TextGallery;
